import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=672b077e&scoped=true"
import script from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=672b077e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b077e",
  null
  
)

export default component.exports